<template>
    <div>
        <v-card>
            <v-card-title class="d-flex justify-content-between">
                <span class="headline">Historique de {{ provider.name }}</span>
                <v-btn text @click="closeModal">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <div class="ml-3">
                    Ajouté à la veille le {{ formatDate(provider.add_date) }}
                </div>
                <div v-for="action in provider.actions" class="text-error ml-3">
                    {{ action.type.label }}
                    <span v-if="action.user">
                        par {{ action.user.first_name }} {{ action.user.last_name }}
                    </span>
                    le {{ formatDate(action.created_at) }}
                </div>
            </v-card-text>
            <v-card-text>
                <div v-if="vtcDiffs.length === 0">
                    Nous n'avons pas encore détecté de modification pour ce prestataire
                </div>
                <div>
                    <v-expansion-panels>
                        <v-expansion-panel v-for="diff in vtcDiffs" style="background-color: #f5f5f5;" class="mb-3">
                            <v-expansion-panel-header>
                                Modification du {{ formatDate(diff.created_at, false) }}
                            </v-expansion-panel-header>
                            <v-expansion-panel-content class="bg-white">
                                <div v-for="action in diff.actions" class="border m-2 p-2 rounded">
                                    {{ action.type.label }}
                                    <span v-if="action.user_id">
                                        par {{ action.user.first_name }} {{ action.user.last_name }}
                                    </span>
                                    le {{ formatDate(action.created_at) }}
                                </div>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </div>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
export default {
    name: "VtcDiffHistory",
    props: ["provider"],
    data() {
        return {
            vtcDiffs: [],
        }
    },
    methods: {
        getProviderVtcDiffsActions() {
            this.$global.loading = true
            this.$http.get("/veille-tourisme/vtc/history/" + this.provider.id).then((res) => {
                this.vtcDiffs = res.body.data.vtcDiffs
                this.$global.loading = false
            })
        },
        closeModal() {
            this.$global.$emit("close-history-modal")
            this.vtcDiffs = []
        },
    },
    watch: {
        provider() {
            if (this.provider !== null) {
                this.getProviderVtcDiffsActions()
            }
        },
    },
    created() {
        if (this.provider !== null) {
            this.getProviderVtcDiffsActions()
        }
    },
}
</script>